import React, { FC } from 'react';

import { RemediationWizard } from './RemediationWizard';

export const AddRemediation: FC = () => {
  return <RemediationWizard actionType="Add" />;
};
